import { createTheme } from '@material-ui/core/styles'

const colors = {
    colors: {
      ui: {
        blue: '#224C9C',
        ligthBlue:'#eaedfd',
        grey: '#939393',
        greyLight:'#F2F2F2',
        greenVeryLight:'#10B98129',
        greyDark: '#777777',
        green: '#10B981',
        greenLight: '#2b7c2f',
        red:'#c43a3a',
        redLight:'#FEF2F2',
        yellow:'#EF9113',
      },
    }
   
}
const theme = {
    palette: {
      primary: {
        main: '#000000',
        
      },
      saveButton: {
        main:'#F40B27',
      }
    },
    ...colors
}


export const customTheme = createTheme(theme)